import type { UIObservation } from '~/repository/types/UIObservation'

export enum TimeRange {
  SIX_HOURS = '6h',
  ONE_DAY = '1d',
  ONE_WEEK = '1w',
  TWO_WEEK = '2w',
  ONE_MONTH = '1m',
  THREE_MONTH = '3m',
  ONE_YEAR = '1y',
  ALL = 'all',
}

export enum ObservationCategory {
  VITAL_SIGNS = 'vital-signs',
  SOCIAL_HISTORY = 'social-history',
  IMAGING = 'imaging',
  LABORATORY = 'laboratory',
  PROCEDURE = 'procedure',
  SURVEY = 'survey',
  EXAM = 'exam',
  THERAPY = 'therapy',
  ACTIVITY = 'activity',
  ENCOUNTER = 'encounter',
  TECHNICAL = 'technical',
  COMPUTED = 'computed',
}

export enum ObservationCategoryTranslations {
  'vital-signs' = 'Signe vital',
  'social-history' = 'Social',
  'imaging' = 'Imagerie',
  'laboratory' = 'Laboratoire',
  'procedure' = 'Procédure',
  'survey' = 'Questionnaire',
  'exam' = 'Examen',
  'therapy' = 'Thérapie',
  'activity' = 'Activité',
  'encounter' = 'Rencontre',
  'technical' = 'Technique',
  'computed' = 'Calculé',
}

export enum InjectionMode {
  CONTINUE = 'continue',
  DISCREET = 'discreet',
}

export interface ObservationDomain {
  startDate: Date
  endDate: Date
}

export interface ChartDimension {
  width: number
  height: number
  margin: { top: number; left: number; right: number; bottom: number }
}

export interface EventData {
  title: string
  codes: string[]
  link?: string
  type: EventDataType
  observations?: UIObservation[]
}

export enum EventDataType {
  OBSERVATION = 'observation',
  ENCOUNTER = 'encounter',
}
